import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store, persistor } from "./store/storage/store";
import { PersistGate } from "redux-persist/integration/react";
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module";
import "./i18n";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import SessionProvider from "./providers/session";
import { CAPTCHA_TOKEN } from "./config/constants";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import ModalProvider from "./providers/modal";
import { Modal, Snackbar } from "./ui";
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ThemeProvider from "./providers/theme";
import SnackbarProvider from "./providers/snackbar";
import { environment } from "./config/environment";

Sentry.init({
  dsn: "https://3061cf4c505a4d0f867543c9276883a9@o918411.ingest.sentry.io/5883067",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});


export const IndexApp = () => {

  const [queryClient] = useState(
    () => new QueryClient({
      defaultOptions: {
        queries: {
          retry: 2,
          retryDelay: 500
        }
      }
    })
  )


  useEffect(() => {
    ReactGA.initialize(environment.GA4_ID);
    if (environment.isProduction) {
      TagManager.initialize({ gtmId: environment.GTM_ID });
    }
  }, []);


  return (
    <GoogleReCaptchaProvider reCaptchaKey={CAPTCHA_TOKEN}>
      <Provider store={store}>
        <PersistGate persistor={persistor} loading={null}>
          <BrowserRouter>
            <QueryClientProvider client={queryClient}>
              <ReactQueryDevtools />

              <SnackbarProvider>
                <SessionProvider>
                  <ModalProvider>
                    <ThemeProvider>
                      <Snackbar />
                      <Modal />
                      <App />
                    </ThemeProvider>
                  </ModalProvider>
                </SessionProvider>
              </SnackbarProvider>
            </QueryClientProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </GoogleReCaptchaProvider>
  );
};




ReactDOM.render(<IndexApp />, document.getElementById("root"));
